// extracted by mini-css-extract-plugin
export default {"mainMenu__link__sub":"SubMenu_mainMenu__link__sub__1OoTZ","active":"SubMenu_active__dpSma","subMenu__about":"SubMenu_subMenu__about__293fC"};